import Marionette from 'backbone.marionette';
import core_layouts from '../../../../core/layouts';
import { TableLayout } from '../../layouts';
import pages, {
	AdvertisingView,
	LadderTable,
	LadderHeader,
	MatchUpLayout,
	MatchUpHeader,
	MatchUpUsers,
	CelebrityPopup
} from '../../views';

import components from '../../../../core/views/components';

import collections, {
	OverallLadder,
	Positions,
	CelebrityTeams
} from '../../collections';

import { League, ShareModel, Coach } from '../../../../core/models';

import { LeagueTeams, Players } from '../../../../core/collections';

import '../../styles/leagues/leagues-form.styl';
import '../../styles/leagues/league-table.styl';
import '../../styles/coming-soon.styl';
import {
	FantasyTeam,
	MatchUpModel,
	FixtureModel,
} from "../../models";
import { sizes_for_big_ad, isMobileView } from '../../../../core/utils';


// trying to force 160 x 600 size 
// ad code didnt hve an ad of this size
// have implemented the sidebar to show mrec size ad
const SIDEBAR_AD_SIZE = [300, 250];

export class LeaguesController extends Marionette.Object {
	/**
	 * Start method for each controller method
	 */
	start(data) {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			widgetsSidebar = new core_layouts.WidgetsSidebar();

		if( data.adSidebarArgs ) {
			const advertisingSidebar = new AdvertisingView(data.adSidebarArgs);
			widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);
		}

		if( data.adFooterArgs ) {
			const advertisingFooter = new AdvertisingView(data.adFooterArgs);
			rootView.getRegion('ads_container').show(advertisingFooter);
		}

		if (data.top_content) {
			rightSidebarLayout.getRegion('top_content').show(data.top_content);
		}
		rightSidebarLayout.getRegion('content').show(data.content);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);

		rootView.getRegion('main').show(rightSidebarLayout);

	}

	/**
	 * Build league table layout
	 * @param data
	 * @returns {*}
	 */
	returnLeaguesTableLayout(data) {
		const
			loadMoreView = new components.LoadMoreView(),
			leaguesLayout = new TableLayout();

		leaguesLayout.getRegion('load_more').show(loadMoreView);
		if (data.header_page) {
			leaguesLayout.getRegion('header_page').show(data.header_page);
		}
		leaguesLayout.getRegion('table_body').show(data.table_body);

		return leaguesLayout;
	}

	/**
	 * Method for fantasy/leagues
	 */
	leagues() {
		const
			table_data = {
				'table_body': new pages.MyLeagueTableView({
					collection: new collections.Leagues(),
					regeneration: new collections.RegenerateLeaguesCollection(),
					rounds: new collections.Rounds(),
					coach: new Coach(),
					players: new Players(),
					user_team: new FantasyTeam()
				}),
				'header_page': new pages.RegenerationBarView()
			},
			start_data = {
				'content': this.returnLeaguesTableLayout(table_data),
				'adSidebarArgs': {
					ad_id: 'league-list-view-ad-slot-1',
					ad_path:'leagues',
					size: SIDEBAR_AD_SIZE,
					pos: 2,
				},
				'adFooterArgs': {
					ad_id: 'league-list-view-ad-slot-3',
					ad_path:'leagues',
					size: sizes_for_big_ad(),
					pos: 3,
				}
			};

		this.start(start_data);
	}

	/**
	 * Method for fantasy/league/create
	 */
	leagueCreate() {
		const start_data = {
			'content': new pages.LeagueCreateView({
				model: new League(),
				rounds: new collections.Rounds()
			}),
			'adSidebarArgs': {
				ad_id: 'league-create-ad-slot-1',
				ad_path:'leagues/create',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			},
			'adFooterArgs': {
				ad_id: 'league-create-ad-slot-3',
				ad_path:'leagues/create',
				size: sizes_for_big_ad(),
				pos: 3,
			}
		};

		this.start(start_data);
	}

	/**
	 * Method for fantasy/league/:league_id/invites
	 * @param league_id
	 */
	invitesAfterCreateLeague(league_id) {
		this.leagueInvites(league_id, true);
	}

	/**
	 * Method for fantasy/league/:league_id/congratulation
	 * @param league_id
	 */
	leagueCongratulation(league_id) {
		const start_data = {
			'content': new pages.LeagueCongratulationView({
				league_id,
				show_header: true,
				model: new League(),
			}),
			'adSidebarArgs': {
				ad_id: 'league-create-ad-slot-1',
				ad_path:'leagues/create',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			},
			'adFooterArgs': {
				ad_id: 'league-create-ad-slot-3',
				ad_path:'leagues/create',
				size: sizes_for_big_ad(),
				pos: 3,
			}
		};

		this.start(start_data);
	}

	/**
	 * Method for fantasy/league/:league_id/manage
	 * @param league_id
	 */
	leagueSettings(league_id) {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			leagueSettingsView = new pages.LeagueSettingsView({
				model: new League(),
				league_id,
				rounds: new collections.Rounds(),
				teams: new LeagueTeams()
			}),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			celebrityPopup = new CelebrityPopup({
				league_id,
				collection: new CelebrityTeams()
			}),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'leagues-settings-ad-slot-1',
				ad_path:'leagues/settings',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'leagues-settings-ad-slot-3',
				ad_path:'leagues/settings',
				size: sizes_for_big_ad(),
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);
		rightSidebarLayout.getRegion('content').show(leagueSettingsView);
		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
		rootView.getRegion('coach').show(celebrityPopup);
	}

	/**
	 * Method for fantasy/league/join
	 */
	leagueJoin(code) {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			leaguesLayout = new TableLayout(),
			leagueJoinBar = new pages.leagueJoinBar(),
			joinFilter = new pages.JoinFilterView(),
			leagueJoinView = new pages.LeagueJoinView({
				collection: new collections.Leagues(),
				model: new League(),
				rounds: new collections.Rounds(),
				code
			}),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			loadMoreView = new components.LoadMoreView(),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'league-settings-ad-slot-1',
				ad_path:'leagues/settings',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'league-settings-ad-slot-3',
				ad_path:'leagues/settings',
				size: sizes_for_big_ad(),
				pos: 3,
			});


		leaguesLayout.getRegion('load_more').show(loadMoreView);
		leaguesLayout.getRegion('header_page').show(joinFilter);
		leaguesLayout.getRegion('table_body').show(leagueJoinView);

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);
		rightSidebarLayout.getRegion('top_content').show(leagueJoinBar);
		rightSidebarLayout.getRegion('content').show(leaguesLayout);
		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	/**
	 * Method for fantasy/league/:league_id/manage/invites
	 * @param league_id
	 * @param is_after_create
	 */
	leagueInvites(league_id, is_after_create) {
		const start_data = {
			'content': new pages.LeagueInvitesView({
				league_id,
				model: new League(),
				share: new ShareModel(),
				is_after_create: !!is_after_create
			}),
			'adSidebarArgs': {
				ad_id: 'league-invite-ad-slot-1',
				ad_path:'leagues/invite',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			},
			'adFooterArgs': {
				ad_id: 'league-invite-ad-slot-3',
				ad_path:'leagues/invite',
				size: sizes_for_big_ad(),
				pos: 3,
			}
		};

		this.start(start_data);
	}

	/**
	 * Method for fantasy/league/regeneration
	 */
	leaguesRegenerateList() {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			leaguesLayout = new TableLayout(),
			regenerationStep1 = new components.RegenerationHeaderView({
				step_number: 'step1'
			}),
			regenerateLeagueTable = new pages.RegenerateLeagueTableView({
				collection: new collections.RegenerateLeaguesCollection(),
				rounds: new collections.Rounds(),
				coach: new Coach(),
				players: new Players(),
			}),
			loadMoreView = new components.LoadMoreView(),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'league-create-ad-slot-1',
				ad_path:'leagues/create',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'league-create-ad-slot-3',
				ad_path:'leagues/create',
				size: sizes_for_big_ad(),
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		leaguesLayout.getRegion('load_more').show(loadMoreView);
		leaguesLayout.getRegion('header_page').show(regenerationStep1);
		leaguesLayout.getRegion('table_body').show(regenerateLeagueTable);

		rightSidebarLayout.getRegion('content').show(leaguesLayout);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);
		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	/**
	 * Method for league/:league_id/regenerate
	 * @param league_id
	 */
	leagueRegenerate(league_id) {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			leaguesLayout = new TableLayout(),
			regenerationStep2 = new components.RegenerationHeaderView({
				step_number: 'step2'
			}),
			regenerationRestart = new pages.RegenerationRestartView({
				league_id,
				model: new League(),
				rounds: new collections.Rounds()
			}),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'league-create-ad-slot-1',
				ad_path:'leagues/create',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'league-create-ad-slot-3',
				ad_path:'leagues/create',
				size: sizes_for_big_ad(),
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		leaguesLayout.getRegion('header_page').show(regenerationStep2);
		leaguesLayout.getRegion('table_body').show(regenerationRestart);

		rightSidebarLayout.getRegion('content').show(leaguesLayout);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);
		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	/**
	 * Method for fantasy/league/:league_id/regenerate/invite/:old_league_id
	 * @param league_id
	 */
	leagueRegenerateInvites(league_id, old_league_id) {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			leaguesLayout = new TableLayout(),
			regenerationStep3 = new components.RegenerationHeaderView({
				step_number: 'step3'
			}),
			regenerationInvite = new pages.RegenerationInviteView({
				league_id,
				old_league_id,
				share: new ShareModel(),
				model: new League(),
			}),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'league-create-ad-slot-1',
				ad_path:'leagues/create',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'league-create-ad-slot-3',
				ad_path:'leagues/create',
				size: sizes_for_big_ad(),
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		leaguesLayout.getRegion('header_page').show(regenerationStep3);
		leaguesLayout.getRegion('table_body').show(regenerationInvite);

		rightSidebarLayout.getRegion('content').show(leaguesLayout);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);
		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	/**
	 * Method for fantasy/league/:league_id/regenerate/congratulation
	 * @param league_id
	 */
	leagueRegenerateCongratulation(league_id) {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			leaguesLayout = new TableLayout(),
			regenerationStep4 = new components.RegenerationHeaderView({
				step_number: 'step4'
			}),
			leagueCongratulationView = new pages.LeagueCongratulationView({
				league_id,
				show_header: false,
				model: new League()
			}),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'league-create-ad-slot-1',
				ad_path:'leagues/create',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'league-create-ad-slot-3',
				ad_path:'leagues/create',
				size: sizes_for_big_ad(),
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		leaguesLayout.getRegion('header_page').show(regenerationStep4);
		leaguesLayout.getRegion('table_body').show(leagueCongratulationView);

		rightSidebarLayout.getRegion('content').show(leaguesLayout);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);
		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	/**
	 * Method for fantasy/league/:league_id/ladder
	 */
	leagueLadder(league_id) {
		const
			model  = new FixtureModel(),
			rounds = new collections.Rounds();

		const
			rootView           = this.getOption( 'rootView' ),
			leaguesLayout      = new TableLayout(),
			fullWidthLayout = new core_layouts.FullWidth(),
			ladderHeader       = new LadderHeader( {
				league_id,
				model,
				rounds: rounds
			} ),
			leagueRankingsView = new LadderTable( {
				league_id,
				model,
				players: new Players(),
				overallLadder: new OverallLadder(),
				leagueTeams: new LeagueTeams(),
				rounds: rounds
			} ),
			advertisingTop = new AdvertisingView({
				ad_id: 'league-ladder-ad-slot-3',
				ad_path:'leagues/ladder',
				size: sizes_for_big_ad(),
				pos: 1,
			}),
			loadMoreView = new components.LoadMoreView();

		leaguesLayout.getRegion( 'header_page' ).show( ladderHeader );
		leaguesLayout.getRegion( 'table_body' ).show( leagueRankingsView );
		leaguesLayout.getRegion('load_more').show(loadMoreView);

		fullWidthLayout.getRegion( 'content' ).show( leaguesLayout );

		rootView.getRegion( 'main' ).show( fullWidthLayout );
		rootView.getRegion( 'top_ads_container' ).show( advertisingTop );
	}


	leagueFixtures(league_id) {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			leagueFixturesView = new pages.LeagueFixturesView({
				model:   new FixtureModel(),
				league_id,
				players: new Players(),
				rounds:  new collections.Rounds(),
				coach:   new Coach()
			}),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'fixture-ad-slot-1',
				ad_path:'leagues/fixtures',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'fixture-ad-slot-3',
				ad_path:'leagues/fixtures',
				size: sizes_for_big_ad(),
				pos: 3,
			});

		if(isMobileView()) {
			leagueFixturesView.getRegion('top_ad_banner').show(new AdvertisingView({
				ad_id: 'fixture-ad-slot-2',
				ad_path:'leagues/fixtures',
				size: SIDEBAR_AD_SIZE,
				pos: 1,
			}));
		}

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		rightSidebarLayout.getRegion('content').show(leagueFixturesView);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);

		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	matchUp(league_id, home_team_id, away_team_id, round_id = 1) {
		const
			rootView = this.getOption('rootView'),
			sidebarLayout = new core_layouts.BaseSidebar({
				type_sidebar: 'no-top-margin full-width-header'
			}),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			matchUpHeader = new MatchUpHeader(),
			matchUpLayout = new MatchUpLayout({
				league_id, home_team_id, away_team_id, round_id,
				model: new MatchUpModel(),
				league: new FixtureModel(),
				squads: new collections.Squads(),
				rounds: new collections.Rounds(),
				players: new Players(),
				positions: new Positions(),
				coach: new Coach(),
				home_team: new FantasyTeam(),
				away_team: new FantasyTeam()
			}),
			matchUpUsers = new MatchUpUsers(),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'fixture-ad-slot-1',
				ad_path:'leagues/fixtures',
				size: SIDEBAR_AD_SIZE,
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'fixture-ad-slot-3',
				ad_path:'leagues/fixtures',
				size: sizes_for_big_ad(),
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		matchUpLayout.getRegion('users').show(matchUpUsers);

		sidebarLayout.getRegion('top_content').show(matchUpHeader);
		sidebarLayout.getRegion('content').show(matchUpLayout);
		sidebarLayout.getRegion('sidebar').show(widgetsSidebar);

		rootView.getRegion('main').show(sidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}
}

export default LeaguesController;